import { erpAxios } from '.';

const getKomitentSrodstvo= async () => {
  const { data } = await erpAxios.get('/grKomitentSrodstvo');
  return data;
};

export default getKomitentSrodstvo;
